<template>
  <component  :is="tag"
              
              class="liner-heading">
    <span>
      <slot></slot>
    </span>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'h3',
    }
  },
}
</script>

<style scoped>

  .liner-heading {
    display: flex;
    align-items: center;

    margin: 0;
    padding: 0 15px 15px 20px;

    font-size: 16px;
    text-align: center;
    font-weight: normal;
    letter-spacing: 0.51px;
    color: var(--color-primary);
  }

  .liner-heading::after,
  .liner-heading::before {
    content: '';

    flex: 1;

    height: 1px;

    background-color: var(--color-border);
  }

  .liner-heading span {
    margin: 0 10px;
  }

</style>